import { useQuery } from '@tanstack/react-query';
import { plainToClass } from 'class-transformer';

import { journeysApi } from 'api';
import { type ApiQueryOptions } from 'hooks/api/queryHelper';
import { JourneyCheckDeletable } from 'models/journeys/JourneyCheckDeletable';

const checkDeletable = async (id: number) => {
  const [error, response] = await journeysApi.checkDeletable(id);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useCheckDeletable = (id: number, options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: ['journey', id, 'checkDeletableJourney'],
    queryFn: () => checkDeletable(id),
    select: (data) => plainToClass(JourneyCheckDeletable, data),
    ...options,
  });
};

export default useCheckDeletable;
